import React from 'react'
import HomepageMessage from './HomepageMessageBox/HomepageMessage.jsx'
const Right = () => {
    return (
        <>
         <div className='right-box'>
            <HomepageMessage />
         </div>   
        </>
    )
}

export default Right
